//webapp acounttype
export enum AccountType {
	FUNDACCOUNT = 0,
	MARGINACCOUNT = 1,
	USERID = 'u'
}
//app logintype
export enum LoginType {
	USER = 'u',
	PASSPORT = 'p',
	FUNDACCOUNT = '1',
	MARGINACCOUNT = '2'
}

export enum LoginResult {
	SUCCESS = 1,
	FAIL = 0
}